import * as actionTypes from 'modules/serviceHeaders/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const open = () => true;
const close = () => false;

export default createReducer(initialState, {
  [actionTypes.OPEN_MODAL]: open,
  [actionTypes.CLOSE_MODAL]: close,
  [actionTypes.SELECT_DMS_ENTRY]: close,
});
